import React, { memo }  from 'react';
import IconWrapper from './IconWrapper';

const IconAngleRightBold = (props) => (
    <IconWrapper fill={props.fill ? props.fill : "currentColor"} className={`angle-right-bold ${props.className}`} viewBox="0 0 298.6 500">
        <path d="M298.6 250L48.6 0 0 48.6 201.4 250 0 451.4 48.6 500l250-250" />
    </IconWrapper>
);

export default memo(IconAngleRightBold);
